import { AssistedRevenuePage } from './AssistedRevenue.page';

export const AssistedRevenueLoader = () => <AssistedRevenuePage />;
